<template>
    <b-container v-if="item"
                 v-bind:class="[{ busy: item.id === busyItemId }, 'article-row-card', 'opacity-transition', 'mb-2']">
        <pb-spinner v-if="item.id === busyItemId"></pb-spinner>
        <b-row v-bind:class="[{ 'border border-danger': item.requestedAmountState === 'RESERVED' },'content p-3']">
            <b-col md="2" class="m-auto">
                <div class="image">
                    <img @error="$event.target.style.display='none'" class="card-img-top"
                         :src="imageResource(thumbnail, 250)" alt="image"/>
                </div>
            </b-col>
            <b-col md="10">
                <b-row class="article-subtitle">
                    <b-col>
                        {{item.articleDetails.name}}&nbsp;&nbsp;<span v-if="customerArticleNumber">|&nbsp;&nbsp;{{customerArticleNumber}}</span>
                    </b-col>
                </b-row>
                <b-row class="article-title mt-2">
                    <b-col>
                        {{item.articleDetails.primaryDescription ||
                        item.articleDetails.secondaryDescription}}
                    </b-col>
                    <b-col class="text-right">
                        {{item.totalCalculated | currency($currencyFormatting[articlePrice.currency])}}
                    </b-col>
                </b-row>
                <b-row class="article-subtitle mt-2">
                    <b-col>
                        Size: {{selectedSize.value}}|&nbsp;&nbsp;Color: {{selectedColor.value}}&nbsp;&nbsp;
                    </b-col>
                    <b-col class="text-right">
                        Amount: {{item.amount}}&nbsp;&nbsp;|&nbsp;&nbsp;{{item.totalCalculatedPerUnit |
                        currency($currencyFormatting[articlePrice.currency])}} /
                        {{article.quantityUnit}}
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col v-if="item.requestedAmountState === 'RESERVED'">
                        <small class="text-danger">
                            {{ $t("warning_amount_reserved") }}
                        </small>
                    </b-col>
                    <b-col class="text-right">
                        <b-button class="pr-0" @click="removeItem({cart: cart, item: item})" variant="link"><i
                                class="fal fa-times fa-inline"></i>
                            REMOVE
                        </b-button>
                    </b-col>
                </b-row>
            </b-col>

        </b-row>
    </b-container>

</template>

<script>

    import CartOverviewItemBase from "./CartOverviewItemBase";

    export default {
        name: 'cart-overview-item',
        extends: CartOverviewItemBase,
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .article-row-card {
        .image {
            img {
                max-height: 80px;
            }

        }
    }
</style>
